/**
 * Utility module to remove the need to use React.PropsWithChildren with additional muting of required types
 */

/** Shorthand type to make type declarations below a bit less verbose */

/**
 * Interface used to create a browser message channel:
 * https://developer.mozilla.org/en-US/docs/Web/API/BroadcastChannel
 */

/** All possible location or pages from where contact support button can be clicked */
export let ContactSupportLocations = /*#__PURE__*/function (ContactSupportLocations) {
  ContactSupportLocations["feedbackDialog"] = "Feedback dialog";
  ContactSupportLocations["projectEvaluationDeprecatedPage"] = "Project evaluation deprecated page";
  ContactSupportLocations["settingsDeprecatedPage"] = "Settings deprecated page";
  ContactSupportLocations["selectWorkspacePage"] = "select workspace page";
  ContactSupportLocations["faceBlurringV1Warning"] = "Face blurring v1 warning dialog";
  ContactSupportLocations["exceededSubscriptionLimitsBanner"] = "Exceeded subscription limits banner";
  /** Support is requested from subscription expired banner */
  ContactSupportLocations["subscriptionExpiredBanner"] = "Subscription expired banner";
  /** Support is requested from subscription expired page */
  ContactSupportLocations["subscriptionExpiredPage"] = "Subscription expired page";
  /** Support is accessed from in-house analytics page */
  ContactSupportLocations["inHouseAnalytics"] = "In-house analytics";
  /** Support is accessed from premium analytics page */
  ContactSupportLocations["premiumAnalytics"] = "Premium analytics ";
  /** Page show to users when they don't have access to any workspace */
  ContactSupportLocations["noWorkspace"] = "No workspace page";
  /** Page when there is a critical error that impeeds the user to continue */
  ContactSupportLocations["criticalErrorPage"] = "Critical error page";
  /** Support is requested from the teams premium-feature page */
  ContactSupportLocations["teamsPremiumFeature"] = "Teams premium feature page";
  return ContactSupportLocations;
}({});

/**
 * Interface for a generic value/label item.
 * It can be used for handling selectable items
 */

/** Adds null to every property of an interface */

/**
 * Defines the mouse click type.
 * Used for tracking the type of click that triggers an action to open a project or snapshot,
 * which can be a left button click, middle button click, or open context menu action.
 */